module.exports = __webpack_public_path__ + "static/img/6.c4e1ce2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/2/zh/6.png
// module id = kAss
// module chunks = 0